export type Modals = {
    login: boolean;
    logout: boolean;
    profile: boolean;
    packages: boolean;
    report: boolean;
    share: boolean;
    gift: boolean;
    deviceAccess: boolean;
    message: boolean;
    favorites: boolean;
    favoritesNoSport: boolean;
    loginPermission: boolean;
    from?: string;
    completeProfile: boolean;
    profileCompletedMessage: boolean;
};

export const ModalsInitialState: Modals = {
    login: false,
    logout: false,
    profile: false,
    packages: false,
    report: false,
    share: false,
    gift: false,
    deviceAccess: false,
    message: false,
    favorites: false,
    favoritesNoSport: false,
    loginPermission: false,
    completeProfile: false,
    profileCompletedMessage: false
};